mutation SetCallRailIntegrationIsEnabled($input: SetCallRailIntegrationIsEnabledInput!) {
    setCallRailIntegrationIsEnabled(input: $input) {
        callRailIntegration {
            isEnabledForUser
            integrationType
        }
    }
}
